import { mutatorAction } from 'satcheljs';
import ThemeResources from '../store/schema/ThemeResources';
import { store } from '../store/store';
import { getThemeDataName } from '../utils/getThemeDataName';

export const addThemeData = mutatorAction(
    'addThemeData',
    (themeId: string, isDarkTheme: boolean, themeData: ThemeResources) => {
        store.themeData.set(getThemeDataName(themeId, isDarkTheme), themeData);
    }
);
